import { render, staticRenderFns } from "./companyLog.vue?vue&type=template&id=71775624"
import script from "./companyLog.vue?vue&type=script&lang=js"
export * from "./companyLog.vue?vue&type=script&lang=js"
import style0 from "./companyLog.vue?vue&type=style&index=0&id=71775624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports